var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime-corejs2/core-js/object/define-property", "@babel/runtime-corejs2/core-js/object/define-properties", "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors", "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor", "@babel/runtime-corejs2/core-js/object/get-own-property-symbols", "@babel/runtime-corejs2/core-js/object/keys", "core-js/modules/es6.regexp.to-string", "core-js/modules/es6.date.to-string", "core-js/modules/es6.object.to-string", "@babel/runtime-corejs2/core-js/reflect/construct", "core-js/modules/es6.regexp.split", "@babel/runtime-corejs2/helpers/classCallCheck", "@babel/runtime-corejs2/helpers/createClass", "@babel/runtime-corejs2/helpers/assertThisInitialized", "@babel/runtime-corejs2/helpers/inherits", "@babel/runtime-corejs2/helpers/possibleConstructorReturn", "@babel/runtime-corejs2/helpers/getPrototypeOf", "@babel/runtime-corejs2/helpers/defineProperty", "classnames", "lodash.throttle", "prop-types", "react", "../../../../breakpoints", "../Icon/Icon", "./VideoThumbnail.css"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime-corejs2/core-js/object/define-property"), require("@babel/runtime-corejs2/core-js/object/define-properties"), require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"), require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"), require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"), require("@babel/runtime-corejs2/core-js/object/keys"), require("core-js/modules/es6.regexp.to-string"), require("core-js/modules/es6.date.to-string"), require("core-js/modules/es6.object.to-string"), require("@babel/runtime-corejs2/core-js/reflect/construct"), require("core-js/modules/es6.regexp.split"), require("@babel/runtime-corejs2/helpers/classCallCheck"), require("@babel/runtime-corejs2/helpers/createClass"), require("@babel/runtime-corejs2/helpers/assertThisInitialized"), require("@babel/runtime-corejs2/helpers/inherits"), require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"), require("@babel/runtime-corejs2/helpers/getPrototypeOf"), require("@babel/runtime-corejs2/helpers/defineProperty"), require("classnames"), require("lodash.throttle"), require("prop-types"), require("react"), require("../../../../breakpoints"), require("../Icon/Icon"), require("./VideoThumbnail.css"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.defineProperties, global.getOwnPropertyDescriptors, global.getOwnPropertyDescriptor, global.getOwnPropertySymbols, global.keys, global.es6Regexp, global.es6Date, global.es6Object, global.construct, global.es6Regexp, global.classCallCheck, global.createClass, global.assertThisInitialized, global.inherits, global.possibleConstructorReturn, global.getPrototypeOf, global.defineProperty, global.classnames, global.lodash, global.propTypes, global.react, global.breakpoints, global.Icon, global.VideoThumbnail);
    global.VideoThumbnail = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _defineProperties, _getOwnPropertyDescriptors, _getOwnPropertyDescriptor, _getOwnPropertySymbols, _keys, _es6Regexp, _es6Date, _es6Object, _construct, _es6Regexp2, _classCallCheck2, _createClass2, _assertThisInitialized2, _inherits2, _possibleConstructorReturn2, _getPrototypeOf2, _defineProperty3, _classnames, _lodash, _propTypes, _react, _breakpoints, _Icon, _VideoThumbnail) {
  "use strict";

  var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty2(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _defineProperties = _interopRequireDefault(_defineProperties);
  _getOwnPropertyDescriptors = _interopRequireDefault(_getOwnPropertyDescriptors);
  _getOwnPropertyDescriptor = _interopRequireDefault(_getOwnPropertyDescriptor);
  _getOwnPropertySymbols = _interopRequireDefault(_getOwnPropertySymbols);
  _keys = _interopRequireDefault(_keys);
  _construct = _interopRequireDefault(_construct);
  _classCallCheck2 = _interopRequireDefault(_classCallCheck2);
  _createClass2 = _interopRequireDefault(_createClass2);
  _assertThisInitialized2 = _interopRequireDefault(_assertThisInitialized2);
  _inherits2 = _interopRequireDefault(_inherits2);
  _possibleConstructorReturn2 = _interopRequireDefault(_possibleConstructorReturn2);
  _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf2);
  _defineProperty3 = _interopRequireDefault(_defineProperty3);
  _classnames = _interopRequireDefault(_classnames);
  _lodash = _interopRequireDefault(_lodash);
  _propTypes = _interopRequireDefault(_propTypes);
  _react = _interopRequireWildcard(_react);
  _Icon = _interopRequireDefault(_Icon);

  function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

  /**
   * Get the height for the width given, based on 16/9 ratio
   * @param {Number} width
   * @returns {Number}
   */
  var getHeightFromWidth = function getHeightFromWidth(width) {
    return Math.round(width * 9 / 16);
  };
  /**
   * Get the width of the viewport
   * @returns {Number}
   */


  var getViewportWidth = function getViewportWidth() {
    return Math.max(global.document.documentElement.clientWidth, global.innerWidth || 0);
  };

  var VIDEO_PLAYING = 'play';

  var VideoThumbnail = /*#__PURE__*/function (_PureComponent) {
    (0, _inherits2.default)(VideoThumbnail, _PureComponent);

    var _super = _createSuper(VideoThumbnail);

    function VideoThumbnail(props) {
      var _this;

      (0, _classCallCheck2.default)(this, VideoThumbnail);
      _this = _super.call(this, props);
      (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "onScroll", function () {
        if (!_this.props.placeholder && _this.domRoot.current) {
          if (_this.domRoot.current.getBoundingClientRect().top + _this.state.containerHeight < 0 || _this.domRoot.current.getBoundingClientRect().top > global.innerHeight) {
            _this.setState({
              minimized: true
            });
          } else if (_this.state.minimized) {
            _this.setState({
              minimized: false
            });
          }
        }
      });
      (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "onResize", function () {
        return requestAnimationFrame(function () {
          if (!_this.props.placeholder && _this.player.current) {
            var h = _this.player.current.getBoundingClientRect().height;

            _this.setState({
              smallScreen: getViewportWidth() < _breakpoints.nextBreakpoints.MEDIUM,
              containerHeight: h
            });
          }
        });
      });
      (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "onThumbnailClose", function () {
        global.removeEventListener('scroll', _this.onScrollThrottle);

        _this.setState({
          minimized: false
        });
      });
      _this.state = {
        containerHeight: 0,
        minimized: false,
        playerPosition: props.position.split(' ').reduce(function (acc, val) {
          return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty3.default)({}, val, '20px'));
        }, {}),
        smallScreen: false,
        playerState: 'pause'
      };
      _this.player = /*#__PURE__*/_react.default.createRef(null);
      _this.domRoot = /*#__PURE__*/_react.default.createRef(null);
      VideoThumbnail.playerHeight = getHeightFromWidth(props.width) + 6;
      VideoThumbnail.playerHeightSmall = getHeightFromWidth(props.smallWidth) + 4;
      _this.onResizeThrottle = (0, _lodash.default)(_this.onResize, 80);
      _this.onScrollThrottle = (0, _lodash.default)(_this.onScroll, 80);
      return _this;
    }

    (0, _createClass2.default)(VideoThumbnail, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this2 = this;

        if (!this.props.placeholder) {
          var observer = new ResizeObserver(this.onResizeThrottle);
          observer.observe(this.player.current);
          global.addEventListener('scroll', this.onScrollThrottle);
          global.addEventListener('message', function (_ref) {
            var data = _ref.data;
            var event = data.event;

            if (undefined !== event && event === VIDEO_PLAYING) {
              _this2.setState({
                playerState: VIDEO_PLAYING
              });
            }
          }, false);
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        global.removeEventListener('scroll', this.onScrollThrottle);
      }
      /**
       * Determine player display when scroll event is called
       * - if we scroll below the player, minimize it
       * - otherwise, put the player back to its initial position
       */

    }, {
      key: "render",

      /**
       * - player main container is set to match height of actual video element
       *   this prevents container from disappearing and changing element positions
       *   on page when player becomes minimized. this also leaves a nice visual
       *   placeholder space for minimized player to return to when appropriate
       * - player second container is positioned based on the user's options
       */
      value: function render() {
        var _this$state = this.state,
            containerHeight = _this$state.containerHeight,
            minimized = _this$state.minimized,
            playerPosition = _this$state.playerPosition,
            playerState = _this$state.playerState,
            smallScreen = _this$state.smallScreen;
        var _this$props = this.props,
            closeLabel = _this$props.closeLabel,
            placeholder = _this$props.placeholder,
            smallWidth = _this$props.smallWidth,
            video = _this$props.video,
            width = _this$props.width;

        var playerStyle = _objectSpread({}, playerPosition);

        var closeStyle = {
          display: 'none'
        };
        var isMinimized = minimized && playerState === VIDEO_PLAYING;

        if (isMinimized) {
          playerStyle.width = "".concat(smallScreen ? smallWidth : width, "px");
          playerStyle.height = "".concat(smallScreen ? VideoThumbnail.playerHeightSmall : VideoThumbnail.playerHeight, "px");
          closeStyle.display = 'block';
        }

        if (placeholder) {
          return /*#__PURE__*/_react.default.createElement(_VideoThumbnail.StyledVideoPlaceholder, null);
        }

        return /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames.default)('video-thumbnail', {
            'is-minimized': isMinimized
          }),
          ref: this.domRoot,
          style: containerHeight === 0 ? {} : {
            height: "".concat(containerHeight, "px")
          }
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "video-thumbnail__player",
          style: playerStyle,
          ref: this.player
        }, video, /*#__PURE__*/_react.default.createElement("button", {
          className: "video-thumbnail__close",
          style: closeStyle,
          onClick: this.onThumbnailClose
        }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
          color: "black",
          name: "arte-next-close",
          size: "xsmall",
          title: closeLabel
        }))));
      }
    }]);
    return VideoThumbnail;
  }(_react.PureComponent);

  (0, _defineProperty3.default)(VideoThumbnail, "playerHeight", 0);
  (0, _defineProperty3.default)(VideoThumbnail, "playerHeightSmall", 0);
  VideoThumbnail.propTypes = {
    closeLabel: _propTypes.default.string,
    placeholder: _propTypes.default.bool,
    position: _propTypes.default.string,
    smallWidth: _propTypes.default.number,
    video: _propTypes.default.node.isRequired,
    width: _propTypes.default.number
  };
  VideoThumbnail.defaultProps = {
    closeLabel: "Fermer l'aperçu vidéo",
    placeholder: false,
    position: 'bottom right',
    smallWidth: 200,
    width: 300
  };
  var _default = VideoThumbnail;
  _exports.default = _default;
});